import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
// import Button from '@material-ui/core/Button';
// import TextField from '@material-ui/core/TextField';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
// import Box from '@material-ui/core/Box';
// import { Link } from 'react-router-dom';
import config from 'config/api';
import DynamicForm from 'components/UI/DynamicForm';
import BlockButton from 'components/UI/BlockButton';
// import Paragrapher  from 'components/UI/Paragrapher/Paragrapher'
import JobForm from 'components/Forms/JobForm';
import i18n from 'helpers/i18n';
import Immutable from 'immutable';
import LoginForm from 'components/Login/LoginForm';
import ResetPasswordRequestForm from 'components/UI/ResetPassword/ResetPasswordRequestForm';
import Dialog from 'components/UI/Dialog/Dialog'
// import EventSubscriptionRecap from 'components/Event/EventSubscriptionRecap';
// import { formatDate } from 'helpers/stringUtils';
import { connect } from 'react-redux';
import ScrollToElementOnMount from 'components/UI/ScrollToElementOnMount';

import { setCurrentUser, getCurrentUser } from 'ducks/authentication';
const styles = (theme) => {
  return {
    root: {
      width: '100%',
      color: theme.palette.primary.main,
      padding: '0 0 10px 0',
      // color: '#fff',
      '& .MuiTypography-body1': {
        // color: '#fff',
      },
      '& .MuiTypography-h2': {
        // color: '#fff',
        fontSize: '2rem',
        [theme.breakpoints.down('md')]: {
          fontSize: '1.6rem',
        },
      },
      '& .MuiTypography-h4': {
        textAlign: 'center',
        color: theme.palette.primary.main,
        // fontWeight: 'bold',
        [theme.breakpoints.down('md')]: {
          // fontSize: '1rem',
        },
      },
      '& .MuiTypography-h5': {
        // color: '#fff',
        fontSize: '1rem',
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
          fontSize: '1.1rem',
        },
      },
    },
    mainForm: {
      paddingTop: 1,
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    whiteBg: {
      position: 'relative',
      '&:before': {
        position: 'absolute',
        left: 0,
        top: 0,
        content: "' '",
        width: '100%',
        height: '100%',
        // backgroundColor: '#fff',
        backgroundColor: theme.palette.background.paper,
        opacity: 0.9,
      },
    },
    relative: {
      position: 'relative',
    },
    subTitle: {
      // marginTop: 20,
      // fontWeight: 'bold'
    },
    column: {
      // height: '375px',
      height: '280px',
      '&:nth-of-type(1)': {
        borderRight: '1px #ccc solid',
        [theme.breakpoints.down('sm')]: {
          borderRight: 'none',
          borderBottom: '1px #ccc solid',
          borderTop: '1px #ccc solid',
        },
      },
    },
    columnSmall: {
      height: '315px',
      '&:nth-of-type(1)': {
        borderRight: '1px #ccc solid',
        [theme.breakpoints.down('sm')]: {
          borderRight: 'none',
          borderBottom: '1px #ccc solid',
          borderTop: '1px #ccc solid',
        },
      },
    },
    columnPadder: {
      // display: 'flex',
      position: 'relative',
      // height: '100%',
      width: 'calc(100% - 20px)',
      marginRight: 10,
      marginLeft: 10,
    },
    padder: {
      padding: '20px 40px',
      margin: '0 30px 20px',
    },
    // h2: {
    //   color: theme.palette.primary.main,
    //   textAlign: 'center',
    //   padding: '0 20px 20px',
    //   [theme.breakpoints.down('sm')]: {
    //     fontSize: '20px',
    //   },
    // },
    h5: {
      textAlign: 'center',
    },
    h6: {
      fontWeight: 'normal',
    },
    body1: {
      textAlign: 'center',
    },
    recap: {
      '& a': {
        color: theme.palette.primary.main,
      },
    },
    formTitle: {
      textAlign: 'center',
      // color: theme.palette.primary.main,
      // color: '#fff',
      marginBottom: 30,
      [theme.breakpoints.down('sm')]: {
        fontSize: '18px',
      },
    },
    formSubTitle: {
      paddingTop: theme.spacing(3),
      color: theme.palette.tertiary.main,
    },
    passwordReset: {
      marginTop: theme.spacing(3),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
  };
};
class RegistrationTwoStepsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // isFormComplete: true,
      showRecap: false,
      logMessage: false,
      step: props.step ? props.step : 1,
      popinOpen: true
      // showRecap: true,
      // logMessage: 'st',
      // step: 2
    };
    // this._onSubscriptionFormComplete = this._onSubscriptionFormComplete.bind(this);
    // this._onJobFormComplete = this._onJobFormComplete.bind(this);
    // this._onRegistrationComplete = this._onRegistrationComplete.bind(this);
    // this._onRegistrationComplete = this._onFormComplete.bind(this);
    // this._onRegistrationCancel = this._onRegistrationCancel.bind(this);
    // this._onClose = this._onFormComplete.bind(this);
    // this._onLoginFormComplete = this._onFormComplete.bind(this);
    // this._onLoginPasswordReset = this._onLoginPasswordReset.bind(this);
    // this._onClose = this._onClose.bind(this);
  }
  //   componentWillUnmount() {
  // }
  // _onSubscriptionFormComplete(responseData) {
  // }
  _onRegistrationCancel = () => {
    if (this.props.onFormCanceled) {
      this.props.onFormCanceled()
    } else {
    this.setState(
      {
        accountJob: undefined,
        step: 1,
        isNewMember: false,
      },
      () => {
        if (this.props.onResize)
        this.props.onResize();
      },
    );
    }
  };
  _onRegistrationComplete = (r) => {
    //     const {setCurrentUser} = this.props;
    // console.log('COMPLETE', r)
    //     setCurrentUser(r.user);
    const { showRecap } = this.props;
    if (showRecap === true)
    this.setState(
      {
        showRecap: true,
      },
      () => {
        if (this.props.onResize)
        this.props.onResize();
      },
    );
    else this._onFormComplete(r);
    //     // this.setState({step: 3, newUserRole: r.accountJob});
  };
  _onShowJobSelect = () => {
    this.setState(
      {
        step: 5,
      },
      () => {
        if (this.props.onResize)
        this.props.onResize();
      },
    );
  };
  _onJobFormComplete = (o) => {
    this.setState(
      {
        accountJob: o.values.accountJob,
        step: 2,
        isNewMember: true,
      },
      () => {
        if (this.props.onResize)
        this.props.onResize();
      },
    );
  };
  _onLoginPasswordReset = () => {
    this.setState(
      {
        accountJob: undefined,
        step: 3,
      },
      () => {
        if (this.props.onResize)
        this.props.onResize();
      },
    );
  };
  _onFormComplete = () => {
    const { onClose, onFormComplete, closeOnComplete } = this.props;
    // console.log('BUBBLED !', onFormComplete)
    const { isNewMember, logMessage, accountJob } = this.state;
    // console.log({
    //   logMessage,
    //   accountJob
    // })
    if (onFormComplete === undefined) {
      if (onClose !== undefined) onClose();
    } else {
      onFormComplete({
        isNewMember: isNewMember,
        accountJob: accountJob,
      });
      // console.log('b')
      if (closeOnComplete === true) {
        // console.log('c')
        onClose();
      }
    }
  };
  _closePopin = () => {
    this.setState({popinOpen: false});
  }
  render() {
    const {
      // onClose,
      classes,
      $$event,
      $$events,
      onResize,
      title,
      $$user,
      showLogin,
      // showRecap,
      // extraFields,
    } = this.props;
    //
    const {
      // isFormComplete,
      isNewMember,
      // logMessage,
      showRecap,
      accountJob,
      step,
      logMessage,
      popinOpen,
    } = this.state;
    const moduleConfig = {
      module: 'account',
      fetchUrl: config.registration + '/edit',
      postUrl: config.registration + '/edit',
      redirectAfterEdit: false,
      afterEdit: 'onFormComplete',
      afterEditLog: '',
      afterEditHideForm: true,
      btCancel: true,
      onFormCancel: this._onRegistrationCancel,
      btCancelLabel: 'Retour',
      btSubmitLabel: 'Envoyer',
    };
    // const hiddenFields = $$user.get('role') === 'admin' || $$user.get('role') === 'staff' ? [] : ['accountJob'];
    const hiddenFields = $$user !== undefined && $$user.get('role') === 'admin'  ? [] : ['accountJob'];
    // const hiddenFields = [];
    // const jobCategories = {
    //   md: "isMd",
    //   sf: "isSf",
    //   lb: "isLb",
    //   sf: "isSf",
    //   in: "isIn",
    // };
    const jobCategories = config.getJobsCategories();
    // console.log({ jobCategories });
    const jobCategory = accountJob === undefined ? [] : [jobCategories[accountJob]];

    // console.log({ jobCategory });
    let ef = {};
    if ($$event !== undefined && $$event.get('id') !== undefined)
    ef = {
      fromEvent: $$event.get('id'),
    };
    else if ($$events !== undefined && $$events.get(0) !== undefined)
    ef = {
      fromEvents: $$events.map((e) => e.get('id')).toArray(),
    };
    if (accountJob !== undefined)
    ef.accountJob = accountJob;
    // console.log({showRecap})
    const extraFields = Immutable.fromJS(ef);
    // console.log(step)
    // console.log('DEBUG', $$event, $$events);
    const userRole = $$user !== undefined ? $$user.get('role') : false;
    const userJob = $$user !== undefined ? $$user.get('job') : false;
    // console.log({hiddenFields, extraFields: extraFields.toJS()})
    return (
      <div className={classes.root}>

        <If condition={step === 1}>
          <ScrollToElementOnMount />
          <Grid container spacing={0} alignItems="center" justify="space-around" style={{textAlign: showLogin !== false ? undefined : 'center'}}>
            <Grid item={true} xs={12}>
              <Box className={classes.whiteBg} >
                <div className={classes.relative}>
                  <If condition={userRole === 'member' || userRole === false || userRole === 'visitor'}>
                    <Typography variant="h4" color="primary" className={classes.subTitle} >
                      <If condition={$$event !== undefined || ($$events !== undefined && $$events.size === 1)}>
                        Pour vous inscrire à votre réunion,<br />merci de vous identifier, ou de créer un compte
                      </If>
                      <If condition={$$events !== undefined && $$events.size > 1}>
                        Pour vous inscrire à vos réunions,<br />merci de vous identifier, ou de créer un compte
                      </If>
                    </Typography>
                  </If>
                  <If condition={userRole === 'staff' || userRole === 'admin' || userJob === 'lb'}>
                    <Typography variant="h5" color="primary" className={classes.subTitle} >
                      VOUS SOUHAITEZ INSCRIRE ...
                    </Typography>
                  </If>
                </div>
              </Box>
            </Grid>
            <If condition={showLogin !== false}>
              <Grid item={true} xs={12} md={showLogin !== false ? 6 : false} className={clsx(classes.column, classes.whiteBg)}>
                <div className={classes.relative}>
                  <Typography variant={'h5'} className={classes.formTitle} gutterBottom={true}>
                    {i18n.get('loginFormTitle')}
                  </Typography>
                  <LoginForm
                    onFormComplete={this._onLoginFormComplete}
                    onPasswordResetRequest={this._onLoginPasswordReset}
                    extraFields={extraFields}
                    />
                </div>
              </Grid>
            </If>
            <Grid item={true} xs={12} md={showLogin !== false ? 6 : 12} className={clsx(classes.column, classes.whiteBg)}>
              <div className={classes.relative}>
                <Typography variant={'h5'} className={classes.formTitle} gutterBottom={true}>
                  {i18n.get('registrationFormTitle')}
                </Typography>
                <Button variant="contained" color="secondary" size="large" onClick={this._onShowJobSelect}>
                  S'inscrire
                </Button>
              </div>
            </Grid>
          </Grid>
        </If>
        <If condition={step === 2}>
          <ScrollToElementOnMount />
          <If condition={i18n.has('registrationFormTitle') === true}>
            <Box  mb={4}>
              <If condition={showLogin === false}>
                <Typography variant={'h2'} className={classes.formTitle} gutterBottom={true}>
                  {i18n.get('registrationFormTitle')}
                </Typography>
              </If>
              <If condition={showLogin !== false}>
                <Typography variant={'h2'} className={classes.formTitle} gutterBottom={true}>
                  {i18n.get('registrationFormTitle')}
                </Typography>
              </If>

            </Box>
          </If>
          <If condition={i18n.has('registrationFormInstructions') === true}>
            <Box className={classes.whiteBg} mb={4}>
              <Typography variant={'h6'} className={classes.h6} style={{ position: 'relative' }}>
                {i18n.get('registrationFormInstructions')}
              </Typography>
            </Box>
          </If>
          <Box align="left" className={clsx(classes.mainForm, classes.whiteBg)}>
            <div className={classes.relative}>
              <DynamicForm
                moduleConfig={moduleConfig}
                onFormReady={onResize}
                onFormComplete={this._onRegistrationComplete}
                formFooter={
                  <If condition={i18n.has('registrationFormFooter')}>
                    <div>{i18n.get('registrationFormFooter')}</div>
                  </If>
                }
                extraFields={extraFields}
                forceHiddenFields={hiddenFields}
                onFormCancel={this._onRegistrationCancel}
                initialCategories={jobCategory}
                />

              <If condition={i18n.has('registrationLogLegend1')}>
                <br />
                <Typography variant={'body1'} classes={{ root: classes.legend }} gutterBottom>
                  {i18n.get('registrationLogLegend1', { prettyfy: true })}
                </Typography>
              </If>
              <If condition={i18n.has('registrationLogLegend2')}>
                <hr />
                <Typography variant={'body1'} classes={{ root: classes.legend }} gutterBottom>
                  {i18n.get('registrationLogLegend2', { prettyfy: true })}
                </Typography>
              </If>
            </div>
          </Box>
        </If>
        <If condition={step === 3}>
          <ScrollToElementOnMount />
          <div className={classes.whiteBg}>
            <div className={clsx(classes.passwordReset, classes.relative)}>
              <ResetPasswordRequestForm onFormCancel={this._onRegistrationCancel} />
            </div>
          </div>
        </If>
        <If condition={step === 4}></If>
        <If condition={step === 5}>
          <ScrollToElementOnMount />
            <Dialog closeButton={false} disableBackdropClick={true} open={popinOpen}>
              <Box mb={2}>
              <Typography variant="body1">Les données recueillies dans le présent formulaire permettent de gérer votre participation à « L'Université des Microbiotes » (*). Ce traitement de données à caractère personnel, initié par BIOCODEX (agissant en tant que responsable de traitement) et organisé par K PARTICULIER (agissant en tant que sous-traitant pour le compte de BIOCODEX), est nécessaire aux fins des intérêts légitimes poursuivis par BIOCODEX (la gestion des manifestations à caractère promotionnel et scientifique). Vos données sont traitées de manière confidentielle et sécurisée, sont destinées exclusivement à BIOCODEX et à l'organisateur de l'évènement, et conservées jusqu'à 5 ans après la réalisation de l'évènement. Conformément au règlement général sur la protection des données (RGPD) et à la loi Informatique et Libertés modifiée, vous pouvez exercer, sur les données qui vous concernent et en justifiant de votre identité, un droit d'accès, de rectification, d'effacement (droit à l'oubli), de limitation, d'opposition, auprès du délégué à la protection des données (DPO) de BIOCODEX, par voie électronique : dpo@biocodex.com ou postale : DPO BIOCODEX – 7 avenue Gallieni – 94250 GENTILLY, vous pouvez exercer le droit d'introduire une réclamation auprès d'une autorité de contrôle, le cas échéant, auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL).</Typography>
              </Box>
              <Box align="middle" mb={3}>
              <Button variant="contained" color="primary" onClick={this._closePopin}>OK</Button>
              </Box>
            </Dialog>
          <Grid container spacing={0} alignItems="center" justify="space-around" style={{width: '100%'}}>
            <If condition={title !== undefined && title !== false}>
              <Grid item={true} xs={12}>
                <Box className={classes.whiteBg}  pb={2} mb={4}>
                  <div className={classes.relative}>
                    <If condition={userRole !== 'staff' && userRole !== 'admin' && userJob !== 'lb'}>
                      <Typography variant="h2" gutterBottom={true} >
                          Je n'ai pas de compte
                      </Typography>
                    </If>
                    <If condition={userRole === 'staff' || userRole === 'admin' || userJob === 'lb'}>
                      <Typography variant="h2" gutterBottom={true} >
                        VOUS SOUHAITEZ INSCRIRE ...
                      </Typography>
                    </If>
                  </div>
                </Box>
              </Grid>
            </If>
            <Grid item={true} xs={12} md={6} className={clsx(classes.columnSmall)}>
              <div className={clsx(classes.columnPadder, classes.whiteBg)}>
                <div className={classes.relative}>
                  <If condition={userRole !== 'staff' && userRole !== 'admin' && userJob !== 'lb'}>
{/*                  <Typography variant={'h4'} className={classes.formSubTitle} gutterBottom={true}>
                    <br />
                    Vous êtes un professionnel de santé
                  </Typography>*/}
                  <Typography variant={'h4'} className={classes.formTitle} gutterBottom={true}>
                    Je suis un professionnel de santé français
                  </Typography>
                </If>
                <If condition={userRole === 'staff' || userRole === 'admin' || userJob === 'lb'}>
                  <Typography variant={'h4'} className={classes.formSubTitle} gutterBottom={true}>
                    <br />
                    Un professionnel de santé français
                  </Typography>
                </If>

                  <JobForm
                    userRole={undefined}
                    onFormComplete={this._onJobFormComplete}
                    showRequiredLegend={false}
                    fieldsSet={1}
                    />
                </div>
              </div>
            </Grid>
            <Grid item={true} xs={12} md={6} className={clsx(classes.columnSmall)}>
              <div className={clsx(classes.columnPadder, classes.whiteBg)}>
                <div className={classes.relative}>
                  <If condition={userRole !== 'staff' && userRole !== 'admin' && userJob !== 'lb'}>
{/*                  <Typography variant={'h4'} className={classes.formSubTitle} gutterBottom={true}>
                    Vous n'êtes pas un professionnel de santé
                    ou vous n'avez pas de numéro RPPS ou ADELI
                  </Typography>*/}
                  <Typography variant={'h4'} className={classes.formTitle} gutterBottom={true}>
                    Je suis un professionnel de santé étranger{' '}
                  </Typography>
                </If>
                <If condition={userRole === 'staff' || userRole === 'admin' || userJob === 'lb'}>
                  <Typography variant={'h4'} className={classes.formSubTitle} gutterBottom={true}>
                    <br />
                    Un professionnel de santé étranger
                    <br />
                    <br />
                  </Typography>
                </If>

                  <JobForm
                    userRole={undefined}
                    onFormComplete={this._onJobFormComplete}
                    showRequiredLegend={false}
                    fieldsSet={2}
                    />
                </div>
              </div>
            </Grid>
          </Grid>
        </If>
      </div>
    );
  }
}
const mapStateToProps = ($$state) => {
  return {
    $$user: getCurrentUser($$state),
  }

  ;
};
const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentUser: (user) => {
      dispatch(setCurrentUser(user));
    },
  };
};
export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(RegistrationTwoStepsForm));



// WEBPACK FOOTER //
// ./src/components/Registration/RegistrationTwoStepsForm.jsx